export class OTA_Telephone {
    public shareMarketInd: string = "No";
    public phoneTechType: string;
    public phoneUseType: string;
    public phoneNumber: string;
    public operation: string;
}
